import { IsNotEmpty, IsString, IsUUID } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

export class CreateClassLevelDto {
  @ApiProperty({
    description: 'ID du niveau (UUID v4)',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({ type: 'string', description: 'Code du niveau', example: '6EME' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: 'Libellé du niveau', example: 'Sixième' })
  @IsNotEmpty()
  @IsString()
  label!: string

  @ApiProperty({ type: 'string', description: "Niveau d'éducation", example: 'COLLEGE' })
  @IsNotEmpty()
  @IsString()
  educationLevel!: string
}
